import { FinalizePackageResponse, Platform } from "redmond";
import { finalizeFlightLodging } from "../../../../../api/v0/itinerary-review/finalizeFlightLodging";
import { finalizePackageV2 } from "../../../../../api/v2/itinerary-review/finalizePackage";
import { convertFinalizeResponseToFinalizePackageResponse } from "../../../../../api/v2/itinerary-review/convertFinalizeResponse";
import {
  AVAILABLE,
  getExperimentVariant,
  PACKAGES_SHOPPING_API_V2,
} from "../../../../../context/experiments";
import { store } from "../../../../../store";
import { actions as packageIdentityActions } from "../../../../package-identity/actions";
import { PackagesMachineContext } from "../../types";

export const finalizePackageService = (
  context: PackagesMachineContext
): Promise<{ finalizePackageResponse: FinalizePackageResponse }> => {
  const isV2 =
    getExperimentVariant(context.experiments, PACKAGES_SHOPPING_API_V2) ===
    AVAILABLE;

  if (isV2) {
    if (context.searchKey == null) {
      return Promise.reject(
        new Error("finalizePackageService: missing searchKey for v2 finalize.")
      );
    }
    const searchKey = context.searchKey;
    return finalizePackageV2({ searchKey: { value: searchKey } }).then(
      (response) => {
        // finalize never returns flight/hotel data GetPackage's snapshot doesn't already have
        // (BE never re-shops the Air component; see FinalizePackageV2.scala), but it CAN return a
        // requoted room when stay dates changed. Route any such change through the same Redux path
        // the poll uses rather than patching xstate context directly, so the rest of the page
        // (which reads the snapshot via selectors) picks it up the same way it would any other
        // poll update.
        store.dispatch(
          packageIdentityActions.setPackageDisplayData(
            searchKey,
            response.packageDisplayData
          )
        );
        const finalizePackageResponse =
          convertFinalizeResponseToFinalizePackageResponse(response);
        return { finalizePackageResponse };
      }
    );
  }

  return new Promise((resolve, reject) => {
    finalizeFlightLodging({
      opaqueQuoteRequest: context.opaqueLodgingRequest || "",
      opaquePackageToken: { value: context.opaqueFlightRequest || "" },
      platform:
        context.platform === "desktop" ? Platform.Desktop : Platform.Mobile,
    })
      .then((finalizePackageResponse) => {
        resolve({ finalizePackageResponse });
      })
      .catch((e) => reject(e));
  });
};

